<template>
    <b-button
      type="button"
      size="sm"
      variant="danger"
      v-if="user.status !== this.userStatusToExclude"
      v-on:click="suspendUser"
    >
      <i class="fa fa-plus" ></i> Suspend
    </b-button>
</template>
<script>
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";
    import {User} from "../../../models/User";

    const UserRepo = RepositoryFactory.get('user');

    export default {
        name: 'user-suspend-button',
        props: {
            user: {
                type: Object,
                default: new User(),
            },
        },
        data() {
            return {
                userStatusToExclude: 'deactivated',
            }
        },
        methods: {
            suspendUser() {
                this.$emit('click')
                UserRepo
                    .suspendUser(this.user.id)
                    .then(
                        response =>
                            (
                                this.$emit('suspend', response.data.data)
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            returnErrors(response) {
                this.$emit('click')
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
            },
        },
    }
</script>
